import { lumi } from '@/lib/lumi'
import { useState } from 'react'

interface Superscore {
  _id: string
  userId: string
  test1MathRaw: number
  test1ReadingRaw: number
  test2MathRaw: number
  test2ReadingRaw: number
  bestMathScaled: number
  bestReadingScaled: number
  superscoreTotal: number
  notes?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export function useSuperscores() {
  const [superscores, setSuperscores] = useState<Superscore[]>([])
  const [loading, setLoading] = useState(false)

  const fetchSuperscores = async () => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.sat_superscores.list({
        sort: { createdAt: -1 },
        limit: 50
      })
      setSuperscores(list)
      console.log('Superscores fetched:', list)
    } catch (error) {
      console.error('Failed to fetch superscores:', error)
    } finally {
      setLoading(false)
    }
  }

  const saveSuperscore = async (data: {
    test1MathRaw: number
    test1ReadingRaw: number
    test2MathRaw: number
    test2ReadingRaw: number
    bestMathScaled: number
    bestReadingScaled: number
    superscoreTotal: number
    notes?: string
  }) => {
    try {
      const user = lumi.auth.user
      if (!user) {
        console.warn('User not authenticated, skipping save')
        return null
      }

      const superscore = await lumi.entities.sat_superscores.create({
        ...data,
        userId: user.userId,
        creator: user.userId,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      })
      console.log('Superscore saved:', superscore)
      await fetchSuperscores()
      return superscore
    } catch (error) {
      console.error('Failed to save superscore:', error)
      throw error
    }
  }

  const deleteSuperscore = async (id: string) => {
    try {
      if (typeof id !== 'string' || id === '[object Object]') {
        throw new Error('Invalid ID: must be a string, not an object')
      }
      await lumi.entities.sat_superscores.delete(id)
      console.log('Superscore deleted:', id)
      await fetchSuperscores()
    } catch (error) {
      console.error('Failed to delete superscore:', error)
      throw error
    }
  }

  return {
    superscores,
    loading,
    fetchSuperscores,
    saveSuperscore,
    deleteSuperscore
  }
}
